<template>
    <div>
        <v-dialog
            v-model="display"
            width="500"
            persistent>
            <v-card flat>
                <v-card-title>
                    {{ title }}
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            :label="$t('name')"
                            v-model="form.name"
                            :disabled="uneditableField('name')"
                            :rules="rulse.name">
                        </v-text-field>
                         <v-text-field
                            :label="$t('adderss')"
                            v-model="form.address"
                            :disabled="uneditableField('address')"
                            :rules="rulse.address">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="loading.data || !valid || loading.submit"
                        :loading="loading.submit"
                        @click="submit"
                        >
                        {{ $t("save_btn" )}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';
import uneditableField from '@/utils/uneditableField';
import { mapActions, mapState } from 'vuex';
export default {
    name: "CustomerSiteDialog",
    components: {
        RetryDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            valid: false,
            loading : {
                data: true,
                submit: false
            },
            mode: {
                edit: false,
            },
            form: {
                id: null,
                customer_id: null,
                name: null,
                address: null
            },
            rulse: {
                name: [
                    v => !!v || this.$t("rules_required")
                ]
            }
        }
    },
    computed: {
        ...mapState("sales/site", ["site"]),
        title() {
            if(!this.mode.edit) return this.$t('new_site')
            else return this.$t('edit_site')
        }
    },
    methods: {
        ...mapActions("sales/site", ["fetchSites", "fetchSite", "storeSite", "updateSite"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        uneditableField,
        ...mapActions("sales/dpk", ["fetchDpk"]),
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.form.dpk = dpk.key;
        },
        open(params) {
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.loading.data = true;
            this.display = true;
            this.openDataFetch();
        },
        async openDataFetch() {
            try {
                if(this.mode.edit) {
                    await this.fetchSite(this.openParams.id);
                    this.form = JSON.parse(JSON.stringify(this.site));
                } else {
                    this.form.customer_id = this.openParams.id;
                    this.getDpkData();
                }
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close();
            }
        },
        submit() {
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeSite(this.form)
                    .then(() => {
                        this.close();
                        this.fetchSites({ customer_id: this.form.customer_id });
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({ color: 'error', message });
                    })
            } else {
                this.updateSite(this.form)
                    .then(() => {
                        this.close();
                        this.fetchSites({ customer_id: this.form.customer_id });
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({ color: 'error', message });
                    })
            }
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
        }
    }
}
</script>